export class StorageKeys {
  static server = 'SERVER';
  static token = 'TOKEN';
  static userInfo = 'UserInfo';
}
